const holder = {
  closeDateRangeSelector(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.internalStateSetter({ isOpen: false });
      document.removeEventListener("mousedown", holder.closeDateRangeSelector)
    }
  }
};

export default {
  refreshOn: ({ selectedDate }) => ([selectedDate]),
  'DatePicker.HeaderWrapper.LeftSide.Input(Keydown)': ({ key, value, hasRemove }, outlet, internalStateSetter) => {
    if (key === 'Enter') {
      if (/^\d?\d\/\d?\d\/\d\d\d\d$/.test(value)) {
        const parts = value.split('/');
        const parsedDate = new Date(parts[2], parts[0] - 1, parts[1]);
        if (parsedDate.valueOf()) {
          outlet({ selectedDate: parsedDate })
        }
      } else if (hasRemove) {
        outlet({ selectedDate: null })
      }
      internalStateSetter({ entryVal: null, isOpen: false })
    }
  },
  'DatePicker.HeaderWrapper.LeftSide.Input': ({ value }, outlet, internalStateSetter) => {
    internalStateSetter('entryVal', value);
    if (/^\d?\d\/\d?\d\/\d\d\d\d$/.test(value)) {
      const parts = value.split('/');
      const parsedDate = new Date(parts[2], parts[0] - 1, parts[1]);
      if (parsedDate.valueOf()) {
        internalStateSetter({ entryVal: null, selectedDate: parsedDate, isOpen: false })
        outlet({ selectedDate: parsedDate })
      }
    } else {
      internalStateSetter({ entryVal: value })
    }
  },
  'DatePicker.HeaderWrapper': ({ isOpen, containerRef }, _, internalStateSetter) => {
    holder.internalStateSetter = internalStateSetter
    holder.containerRef = containerRef
    internalStateSetter({ isOpen: !isOpen });
    if (isOpen) {
      document.removeEventListener("mousedown", holder.closeDateRangeSelector);
    } else {
      document.addEventListener("mousedown", holder.closeDateRangeSelector);
    }
  },
  'DatePicker.CalendarWrapper.Calendar': ({ selectedDate }, outlet, internalStateSetter) => {
    internalStateSetter({ selectedDate, isOpen: false })
    outlet({ selectedDate })
  }
}